import React from 'react'
import { withRouter } from 'react-router-dom'

import { Toast } from 'primereact/toast'
import { Dropdown } from 'primereact/dropdown'
import { InputTextarea } from 'primereact/inputtextarea'
import Backdrop from '@mui/material/Backdrop';
import { Checkbox } from "primereact/checkbox";
import { MultiSelect } from 'primereact/multiselect'
import CircularProgress from '@mui/material/CircularProgress';
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog'
import { AuthContext } from '../../main/ProvedorAutenticacao'

import NavBar from '../../componentes/Navbar'
import './publicacoes.css'

import ParametrosPublicacoesService from '../../app/service/ParametrosPublicacoesService'
import ProcessoService from '../../app/service/ProcessoService'
import TermosPublicacaoAtividade from './TermosPublicacaoAtividade'

import GrupoTrabalhoService from '../../app/service/GrupoTrabalhoService'
import UsuarioGrupoTrabalhoService from '../../app/service/UsuarioGrupoTrabalhoService'
import TituloAtividadeService from '../../app/service/TituloAtividadeService';
import UsuarioService from '../../app/service/UsuarioService'
import AreaAtuacaoService from '../../app/service/AreaAtuacaoService'

class ParametrosPublicacoes extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      openSpinner: false,
      parametros: false,
      //Usuário que recebe as publicações sem termo correspondente ("Prazos sem Responsável")
      usuarioTriagem: null,
      usuariosTriagem: [],
      //Usuários que recebem o relatório (Excel) de cada processamento na Central de Notificações
      usuariosRelatorio: [],
      selectCheks: [],
      parametro: null,
      tempoDataLimite: '',
      tempoDataFatal: '',
      linkConfiguracoesAtividade: false,
      //Seleção dos processos
      selectProcessos: null,
      selectProcessosSelecao: null,
      modalSelecaoProcesso: false,
      modalProcessos: false,
      processos: [],
      processo: null,
      numeroProcesso: '',
      numeroCnj: '',
      gruposTrabalho: [],
      grupo: null,
      statusProcessuais: [],
      statusProcessual: null,
      cadastrouProcessos: false,
      linkProcessos: false,
      //Parâmetros de Atividades
      modalParametroAtividade: false,
      usuarios: [],
      dtLimite: '',
      dtFatal: '',
      titulos: [],
      titulo: null,
      descricaoAtividade: '',
			//Usuarios que recebe emails
			usuarioEmail: null,
			grupoUsuarioEmail: null,
			linkUsuariosEmail: false,
			usuariosGrupoTrabalho: [],
			usuario: null,
			modalUsuariosGrupo: false,
			selectUsuariosGrupo: null,
			selectUsuariosEmail: null,
			grupoTrabalhoNome: '',
			//Área de Atuação
			areaAtuacao: null,
			areasAtuacao: [],
			//Criar Atividade Termos
			criaAtividadeTermos: false,
			modalTermosPublicacoes: false,
    }

		this.usuariosEmailTemp = [];
		this.usuariosTemp = [];

    this.checks = [
      { name: 'Cria Atividade', key: 'CA' },
      { name: 'Inclui no histórico do processo', key: 'IHP' },
      { name: 'Selecionar processos para criação de atividade', key: 'SPCA' },
      { name: 'Enviar Email', key: 'EEM' },
      { name: 'Selecionar usuários que recebem as publicações', key: 'SUP' }
    ];

    this.parametroService = new ParametrosPublicacoesService();
    this.processoService = new ProcessoService();
    this.grupoTrabalhoService = new GrupoTrabalhoService();
		this.usuarioGrupoTrabalhoService = new UsuarioGrupoTrabalhoService();
    this.tituloAtividadeService = new TituloAtividadeService();
    this.usuarioService = new UsuarioService();
		this.areaAtuacaoService = new AreaAtuacaoService();

		this.onChecksChange = this.onChecksChange.bind(this);
		this.acoesUsuarios = this.acoesUsuarios.bind(this);
		this.consultarUsuariosPorGrupoAtividade = this.consultarUsuariosPorGrupoAtividade.bind(this);
		this.onCriaAtividadeTermosChange = this.onCriaAtividadeTermosChange.bind(this);
  }

  consultarTitulosAtividades = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.tituloAtividadeService.listarParaParametros(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({titulos: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Parâmetros de Publicações', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarUsuarios = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.usuarioService.listarUsuariosEmpresa(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({usuariosGrupoTrabalho: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Parâmetros de Publicações', detail:`${this.state.detail}`, life: 4000});
      })
  }

	listarAreaAtuacao = async () => {
		const usuarioLogado = this.context.usuarioAutenticado;
		await this.areaAtuacaoService.listarAreaAtuacao(usuarioLogado.empresa.codigo)
			.then(response => {
				this.setState({areasAtuacao: response.data});
			}).catch(error => {
				this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Parâmetros de Publicações', detail:`${this.state.detail}`, life: 4000});
			})
	}

  listarGruposTrabalho = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.grupoTrabalhoService.listarGruposUsuario(usuarioLogado.codigo)
      .then(response => {
        this.setState({gruposTrabalho: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Parâmetros de Publicações', detail:'Erro ao carregar Grupos de Trabalhos do usuário', life: 4000});
      });
  }

	consultarUsuariosTriagem = async () => {
		const usuarioLogado = this.context.usuarioAutenticado;
		await this.usuarioService.listarUsuariosEmpresa(usuarioLogado.empresa.codigo)
			.then(response => {
				//Somente usuários ativos podem receber os prazos sem responsável
				this.setState({usuariosTriagem: response.data.filter(u => u.situacao === 0)});
			}).catch(error => {
				this.toast.show({severity:'error', summary: 'Parâmetros de Publicações', detail:`Erro ao consultar usuários: ${error}`, life: 4000});
			})
	}

	consultarParametros = async () => {
		const usuarioLogado = this.context.usuarioAutenticado;
		let para = [];
		await this.parametroService.consultar(usuarioLogado.empresa.codigo)
			.then(response => {
				this.setState({parametros: response.data, usuarioTriagem: response.data.usuarioTriagem,
					usuariosRelatorio: response.data.usuariosRelatorio || [],
					criaAtividadeTermos: response.data.criaAtividadeTermos === 'S'});
					if(response.data.criaAtividade == 'S') {
						para.push('CA');
						this.setState({linkConfiguracoesAtividade: true});
					}

					if(response.data.incluiHistoricoProcesso == 'S') {
						para.push('IHP');
					}

					if(response.data.enviaEmail == 'S') {
          	para.push('EEM');
					}

					this.setState({selectCheks: para});

			}).catch(error => {
				this.toast.show({severity:'error', summary: 'Parâmetros de Publicações', detail:`Erro ao consultar parâmetros: ${error}`, life: 4000});
			})
	}

	onChecksChange(e) {
		let selectedChecks;
		if (e.checked) {
			selectedChecks = [...this.state.selectCheks, e.value];
		} else {
			selectedChecks = this.state.selectCheks.filter(v => v !== e.value);
		}
		this.setState({
			selectCheks: selectedChecks,
			linkConfiguracoesAtividade: selectedChecks.includes('CA'),
			linkUsuariosEmail: selectedChecks.includes('EEM')
		});

	}

	onCriaAtividadeTermosChange(e) {
		if(e.checked) {
			this.setState({criaAtividadeTermos: true, modalTermosPublicacoes: true});
		} else {
			this.setState({criaAtividadeTermos: false, modalTermosPublicacoes: false});
		}
	}

	cadastrarUsuariosAtividade = () => {

		if(this.state.usuario == null) {
			this.toast.show({severity:'error', 
				               summary: 'Parâmetros de Publicações', 
											 detail:'Nenhum usuário foi selecionado', life: 4000});
			return;
		}

		if(this.usuariosTemp != null && this.usuariosTemp.length > 0) {
			for(let i = 0; i < this.usuariosTemp.length; i++) {
				for(let u = 0; u < this.state.usuario.length; u++) {
					
					if(this.usuariosTemp[i].codigoUsuario === this.state.usuario[u].codigo 
						&& this.usuariosTemp[i].grupo === '*'
					  && this.usuariosTemp[i].area === '*') {
						this.toast.show({severity:'error', 
				               summary: 'Parâmetros de Publicações', 
											 detail:'Este usuário já está adicionado para receber prazos com todos os grupo', life: 4000});
								return;
					}
					
					if((this.state.usuario[u].codigo == this.usuariosTemp[i].codigoUsuario) &&
						 (this.usuariosTemp[i].grupo === this.state.grupo.nome) &&
						 (this.state.areaAtuacao != null && this.usuariosTemp[i].area === this.state.areaAtuacao.nome)) {
							this.toast.show({severity:'error', 
				               summary: 'Parâmetros de Publicações', 
											 detail:'Configuração não permitida', life: 4000});
								return;
					}

					if((this.state.usuario[u].codigo == this.usuariosTemp[i].codigoUsuario) &&
						 (this.usuariosTemp[i].grupo === this.state.grupo.nome) &&
						 (this.state.areaAtuacao == null)) {
							this.toast.show({severity:'error', 
				               summary: 'Parâmetros de Publicações', 
											 detail:'Configuração não permitida', life: 4000});
								return;
					}
				}
			}
		}
		
		for(let i = 0; i < this.state.usuario.length; i++) {
			const usuario = {
				codigoUsuario: this.state.usuario[i].codigo,
				nome: this.state.usuario[i].nome,
				codigoGrupo: this.state.grupo != null ? this.state.grupo.codigo : null,
				grupo: this.state.grupo != null ? this.state.grupo.nome : '*',
				codigoArea: this.state.areaAtuacao == null ? null : this.state.areaAtuacao.codigo,
				area: this.state.areaAtuacao == null ? '*' : this.state.areaAtuacao.nome
			}
			this.usuariosTemp.push(usuario);
		}

		this.setState({modalParametroAtividade: true});
	}

	consultarParametrosAtividade = async () => {
		this.setState({openSpinner: true});
		this.usuariosTemp = [];
		if(this.state.parametros.criaAtividade == 'S') {
			this.setState({dtLimite: this.state.parametros.parametrosAtividade.dtLimite});
			this.setState({dtFatal: this.state.parametros.parametrosAtividade.dtFatal});
			this.setState({descricaoAtividade: this.state.parametros.parametrosAtividade.descricao});
			this.setState({titulo: this.state.parametros.parametrosAtividade.titulo});
			for(let i = 0; i < this.state.parametros.parametrosAtividade.usuariosResponsaveis.length; i++) {
				const usuario = {
					codigoUsuario: this.state.parametros.parametrosAtividade.usuariosResponsaveis[i].usuario.codigo,
					nome: this.state.parametros.parametrosAtividade.usuariosResponsaveis[i].usuario.nome,
					codigoGrupo: this.state.parametros.parametrosAtividade.usuariosResponsaveis[i].grupoTrabalho != null ? 
									this.state.parametros.parametrosAtividade.usuariosResponsaveis[i].grupoTrabalho.codigo : null,
					grupo: this.state.parametros.parametrosAtividade.usuariosResponsaveis[i].grupoTrabalho != null ? 
									this.state.parametros.parametrosAtividade.usuariosResponsaveis[i].grupoTrabalho.nome : '*',
					codigoArea: this.state.parametros.parametrosAtividade.usuariosResponsaveis[i].areaAtuacao != null ? 
									this.state.parametros.parametrosAtividade.usuariosResponsaveis[i].areaAtuacao.codigo : null,
					area: this.state.parametros.parametrosAtividade.usuariosResponsaveis[i].areaAtuacao != null ? 
									this.state.parametros.parametrosAtividade.usuariosResponsaveis[i].areaAtuacao.nome : '*'
				}
				this.usuariosTemp.push(usuario);
			}
		}
		this.setState({grupo: null});
		this.setState({areaAtuacao: null});
		this.setState({usuario: null});
		await this.consultarTitulosAtividades();
		await this.consultarUsuarios();
		await this.listarAreaAtuacao();
		await this.listarGruposTrabalho();
		this.setState({modalParametroAtividade: true, openSpinner: false});
	}

	fecharModal(name) {
    this.setState({
        [`${name}`]: false
    });
  }

	async consultarUsuariosPorGrupoAtividade(e) {
		if(e) {
			this.setState({grupo: e.value});
			this.setState({openSpinner: true});
			await this.usuarioGrupoTrabalhoService.listarUsuariosAtivos(e.value.codigo)
				.then(response => {
					this.setState({usuariosGrupoTrabalho: response.data});
					this.setState({openSpinner: false});
				}).catch(error => {
					this.toast.show({severity:'error', 
				                   summary: 'Parâmetros de Publicações', 
											     detail:`Erro ao consultar usuários por grupo de trabalho: ${error}`, life: 4000});
				})
		}
	}

	salvarParametros = async () => {
		const usuarioLogado = this.context.usuarioAutenticado;
		console.log('Data limite ', this.state.dtLimite);
    let ca = 'N';
    let ihp = 'N';
    let eem = 'N';
		let usuariosPrazos = [];
		if(this.state.selectCheks != null && this.state.selectCheks.length > 0) {
      for(let i = 0; i < this.state.selectCheks.length; i++) {
        if(this.state.selectCheks[i] == 'CA') {
          
					if (this.state.dtLimite === null || this.state.dtLimite === undefined || this.state.dtLimite === '') {
						this.toast.show({
							severity: 'error',
							summary: 'Parâmetros de Publicações',
							detail: 'Configuração de data limite é inválida',
							life: 4000
						});
						return;
					}

					if(this.state.titulo == null) {
						this.toast.show({severity:'error', 
				                     summary: 'Parâmetros de Publicações', 
											       detail:'O título da atividade não foi informado', life: 4000});
						return;
					}

					if(this.usuariosTemp == null || this.usuariosTemp.length == 0) {
						this.toast.show({severity:'error', 
				                     summary: 'Parâmetros de Publicações', 
											       detail:'Nenhum usuário informado para receber prazo', life: 4000});
						return;
					}

					ca = 'S';

					for(let i = 0; i < this.usuariosTemp.length; i++) {
						
						var grupo = null;
						if(this.usuariosTemp[i].grupo != '*') {
							grupo = {
								codigo: this.usuariosTemp[i].codigoGrupo
							}
						}

						var area = null;
						if(this.usuariosTemp[i].area != '*') {
							area = {
								codigo: this.usuariosTemp[i].codigoArea
							}
						}

						const usuario = {
							parametrosPublicacoesAtividade: {
								codigo: this.state.parametros.codigo
							},
							usuario: {
								codigo: this.usuariosTemp[i].codigoUsuario
							},
							selecaoGrupo: this.usuariosTemp[i].grupo == '*' ? '*' : 'S',
							grupoTrabalho: grupo,
							selecaoArea: this.usuariosTemp[i].area == '*' ? '*' : 'S',
							areaAtuacao: area
						}
						usuariosPrazos.push(usuario);
					}
				}

				if(this.state.selectCheks[i] == 'IHP') {
					ihp = 'S'
				}

				if(this.state.selectCheks[i] == 'eem') {
					eem = 'S'
				}
			}
		}

		const para = {
			codigo: this.state.parametros.codigo,
			criaAtividade: ca,
			criaAtividadeTermos: this.state.criaAtividadeTermos ? 'S' : 'N',
			incluiHistoricoProcesso: ihp,
			selecaoProcessoCriaAtividade: 'N',
			processos: null,
			enviaEmail: eem,
			selecaoUsuarioRecebe: 'N',
			usuarioTriagem: this.state.usuarioTriagem,
			usuariosRelatorio: this.state.usuariosRelatorio,
			empresa: {
				codigo: usuarioLogado.empresa.codigo
			},
			parametrosAtividade: {
				empresa: {
					codigo: usuarioLogado.empresa.codigo
				},
				descricao: this.state.descricaoAtividade,
				titulo: this.state.titulo,
				dtLimite: this.state.dtLimite,
				dtFatal: this.state.dtFatal,
				usuariosResponsaveis: usuariosPrazos
			}
		}

		this.setState({openSpinner: true});
		await this.parametroService.alterar(para)
			.then(response => {
				this.consultarParametros();
				this.setState({openSpinner: false});
				this.toast.show({severity:'success', 
												 summary: 'Parâmetros de Publicações', 
												 detail:'Parâmetros salvos com sucesso', life: 4000});
			}).catch(error => {
				this.setState({openSpinner: false});
				this.toast.show({severity:'error', 
												 summary: 'Parâmetros de Publicações', 
												 detail:`Falha ao salvar parâmetros: ${error}`, life: 4000});
			})

	}

	acoesUsuarios(rowData) {
		 return(
			<React.Fragment>
				<Button icon="pi pi-trash" className="p-button-rounded p-button-text"
								tooltip="Excluir Pedido"
								onClick={() => this.excluirUsuario(rowData)}
								tooltipOptions={{position: 'top'}}
								style={{width: '20px', height: '10px'}}/>
			</React.Fragment>
		);
	}

	excluirUsuario(usuario) {
		console.log('Usuário ', usuario);
		this.usuariosTemp = this.usuariosTemp.filter(u =>
			!(u.codigoUsuario === usuario.codigoUsuario &&
				u.grupo === usuario.grupo &&
				u.area === usuario.area)
		);
		this.setState({modalParametroAtividade: true});
	}

  async componentDidMount() {
    this.setState({openSpinner: true});
		await this.consultarParametros();
		await this.consultarUsuariosTriagem();
		this.setState({openSpinner: false});
  }

  render() {
    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={this.state.openSpinner}>
          <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
        </Backdrop>
        <div className="content-wrapper">
          <div className="container-fluid">
            <section className="content-header">
              <div className="card card-primary card-outline">
                <div className="card-header">
                  <h3 className="card-title">
                    <i className="fa fa-file-import"></i>
                    <span> Parâmetros de Publicações</span>
                  </h3>
                </div>
                <br></br>
                <div className="check-container">
                  <Checkbox inputId="CA" 
                            name="CA" 
                            value="CA" 
                            onChange={this.onChecksChange} 
                            checked={this.state.selectCheks.indexOf('CA') !== -1} />
                  <strong>Cria Atividade</strong>
                  <a style={{cursor: 'pointer'}} title="Cria atividade ao receber novas publicações" >
                    <i style={{color: 'blue'}} className="pi pi-question-circle"></i>
                  </a>
                  {this.state.linkConfiguracoesAtividade && (
                  <strong>
                    <a onClick={this.consultarParametrosAtividade} style={{cursor: 'pointer', color: 'blue'}}>
                      Configuração
                    </a>
                  </strong>
                  )}
                </div>
                <br></br>
                <div className="check-container">
                  <Checkbox inputId="CAT"
                            name="CAT"
                            value="CAT"
                            onChange={this.onCriaAtividadeTermosChange}
                            checked={this.state.criaAtividadeTermos} />
                  <strong>Criar Atividade Termos</strong>
                  <a style={{cursor: 'pointer'}} title="Quando o texto de uma nova intimação contém os termos cadastrados (todos ou pelo menos um, conforme a regra), é criada automaticamente uma atividade com o título, a descrição e os prazos da regra. Com mais de um responsável, as atividades são distribuídas em rodízio." >
                    <i style={{color: 'blue'}} className="pi pi-question-circle"></i>
                  </a>
                  {/*Sempre visível: os termos podem ser revisados com a função desligada*/}
                  <strong>
                    <a onClick={() => this.setState({modalTermosPublicacoes: true})} style={{cursor: 'pointer', color: 'blue'}}>
                      Configuração
                    </a>
                  </strong>
                </div>
                {this.state.criaAtividadeTermos && (
                <div style={{marginTop: '10px', maxWidth: '420px'}}>
                  <div style={{display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '0.5rem'}}>
                    <label style={{marginBottom: 0}}>Usuário para prazos sem responsável</label>
                    <a style={{cursor: 'pointer'}} title="Publicações que não correspondem a nenhum termo viram uma atividade para este usuário, que as vê em Atividades > Prazos sem Responsável e designa o responsável. Sem usuário, essas publicações ficam sem atividade." >
                      <i style={{color: 'blue'}} className="pi pi-question-circle"></i>
                    </a>
                  </div>
                  <Dropdown value={this.state.usuarioTriagem}
                            options={this.state.usuariosTriagem}
                            optionLabel="nome"
                            optionValue="codigo"
                            onChange={e => this.setState({usuarioTriagem: e.value})}
                            placeholder="Nenhum (publicações sem termo ficam sem atividade)"
                            filter
                            showClear
                            style={{width: '100%', height: '32px'}}
                            className="p-inputtext-sm p-d-block p-mb-1" />
                  {this.state.parametros && this.state.parametros.usuarioTriagem && !this.state.parametros.usuarioTriagemAtivo && (
                    <small className="p-d-block" style={{color: 'red'}}>
                      O usuário configurado ({this.state.parametros.usuarioTriagemNome}) está inativo: as publicações sem termo ficam sem atividade. Escolha outro usuário.
                    </small>
                  )}
                </div>
                )}
                <br></br>
                <div className="check-container">
                  <Checkbox inputId="IHP"
                            name="IHP" 
                            value="IHP" 
                            onChange={this.onChecksChange} 
                            checked={this.state.selectCheks.indexOf('IHP') !== -1} />
                  <strong>Inclui no histórico do processo</strong>
                </div>
                <br></br>
                <div className="check-container">
                  <Checkbox inputId="EEM" 
                            name="EEM" 
                            value="EEM" 
                            onChange={this.onChecksChange} 
                            checked={this.state.selectCheks.indexOf('EEM') !== -1} />
                  <strong>Enviar Email</strong>
									{this.state.linkUsuariosEmail && (
                  <strong>
                    <a style={{cursor: 'pointer', color: 'blue'}}>
                      Usuários
                    </a>
                  </strong>
                  )}
                </div>
                <div style={{marginTop: '10px', maxWidth: '420px'}}>
                  <div style={{display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '0.5rem'}}>
                    <label style={{marginBottom: 0}}>Usuários que recebem o relatório do processamento</label>
                    <a style={{cursor: 'pointer'}} title="A cada processamento de publicações, estes usuários recebem na Central de Notificações uma planilha com os totais e as atividades abertas por usuário." >
                      <i style={{color: 'blue'}} className="pi pi-question-circle"></i>
                    </a>
                  </div>
                  <MultiSelect value={this.state.usuariosRelatorio}
                               options={this.state.usuariosTriagem}
                               optionLabel="nome"
                               optionValue="codigo"
                               onChange={e => this.setState({usuariosRelatorio: e.value})}
                               placeholder="Nenhum (relatório não é enviado)"
                               filter
                               display="chip"
                               style={{width: '100%'}}
                               className="p-inputtext-sm p-d-block p-mb-1" />
                </div>
                <br></br>
                <br></br>
                <div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <button type="button" 
                              className="btn btn-success bg-gradient-success" 
                              onClick={this.salvarParametros}>Salvar</button>
                    </div>
                  </div>
                </div>
               </div>
                {/**Parâmetros de Atividades */}
                <Dialog header="Parâmetros de Atividade"
                       disabled="true"
                       visible={this.state.modalParametroAtividade} 
                       style={{ width: '40vw' }}
                       footer={
                        <div>
                            <Button label="Salvar" 
                                    className="p-button-primary p-button-text"/>
                            &nbsp;
                            <Button label="Fechar"
                                    className="p-button-secondary p-button-text"
                                    onClick={() => this.fecharModal('modalParametroAtividade')}/>
                        </div>
                      }
                      onHide={() => this.fecharModal('modalParametroAtividade')}>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>Data para criação da atividade (dias) após o recebimento</label>
                        <InputText id="dtLimite" style={{width: '100%', height: '32px'}}
                                   type="text"
                                   autoComplete="none"
                                   value={this.state.dtLimite}
                                   onChange={e => this.setState({dtLimite: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>Data para criação da atividade prazo fatal(dias) após o recebimento</label>
                        <InputText id="dtFatal" style={{width: '100%', height: '32px'}}
                                   type="text"
                                   autoComplete="none"
                                   value={this.state.dtFatal}
                                   onChange={e => this.setState({dtFatal: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>Título da Atividade</label>
                        <Dropdown value={this.state.titulo} style={{width: '100%', height: '32px'}} 
                                  options={this.state.titulos} style={{width: '100%', height: '32px'}}
                                  optionLabel="tituloExibir" 
                                  filter showClear filterBy="tituloExibir"
                                  onChange={e => this.setState({titulo: e.target.value})}
                                  id="tituloAtividade"
                                  className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>Descrição da Atividade</label>
                        <InputTextarea id="descricaoAtividade" 
                                       type="text" 
                                       style={{width: '100%'}} 
                                       value={this.state.descricaoAtividade}
                                       onChange={e => this.setState({descricaoAtividade: e.target.value})}
                                       className="p-inputtext-sm p-d-block p-mb-1"
                                       rows={3} cols={30}/>
                      </div>
                    </div>
                  </div>
                  <div className="row">
										 <div className="col-md-4">
                      <div className="form-group">
                        <label>Grupo de Trabalho</label>
												<Dropdown value={this.state.grupo} 
                                  options={this.state.gruposTrabalho} style={{width: '100%'}}
                                  optionLabel="nome" 
                                  filter showClear filterBy="nome"
                                  onChange={this.consultarUsuariosPorGrupoAtividade}
                                  id="grupoTrabalhoConsultaUsuarioAtividade"
                                  className="p-inputtext-sm p-d-block p-mb-1"/>
											</div>
										</div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Usuários</label>
                        <MultiSelect inputId="UsuarioAtividade"
																	   value={this.state.usuario} 
																		 options={this.state.usuariosGrupoTrabalho} 
																		 style={{width: '100%', height: '32px', padding_top: '1px'}} 
																		 onChange={(e) => this.setState({ usuario: e.value })} 
																		 filter showClear filterBy="nome"
																		 optionLabel="nome" />
                      </div>
                    </div>
										<div className="col-md-4">
                      <div className="form-group">
                        <label>Área de Atuação</label>
                        <Dropdown inputId="areaAtuacao"
																	value={this.state.areaAtuacao} 
																	options={this.state.areasAtuacao} 
																	style={{width: '100%', height: '32px', padding_top: '1px'}} 
																	onChange={(e) => this.setState({ areaAtuacao: e.value })} 
																	filter showClear filterBy="nome"
																	optionLabel="nome" />
                      </div>
                    </div>
                  </div>
									<div className="row">
										<div className="col-md-12">
                      <div className="form-group">
										    <Button label="Adicionar" 
												         style={{width: '100%', height: '32px', padding_top: '1px'}} 
															   onClick={this.cadastrarUsuariosAtividade}
																 className="p-button-primary p-button-text"/>
                      </div>
                    </div>
									</div>
									<div className="row">
										 <div className="col-md-12">
                      <div className="form-group">
												 <DataTable value={this.usuariosTemp} 
																		emptyMessage=" "
																		size="small"
																		showGridlines>
													<Column field="nome" header="Usuario"></Column>
												  <Column field="grupo" header="Grupo de Trabalho"></Column>
													<Column field="area" header="Área de Atuação"></Column>
													<Column body={this.acoesUsuarios} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
												</DataTable>
											</div>
										</div>
									</div>
                </Dialog>

                {/**Criar Atividade Termos */}
                <TermosPublicacaoAtividade
                  visible={this.state.modalTermosPublicacoes}
                  empresaId={this.context.usuarioAutenticado != null ? this.context.usuarioAutenticado.empresa.codigo : null}
                  onHide={() => this.setState({modalTermosPublicacoes: false})} />
              </section>
            </div>
        </div>
      </>
    );
  }
}
ParametrosPublicacoes.contextType = AuthContext;
export default withRouter(ParametrosPublicacoes)